// utils/dateUtils.js
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Enable UTC and Timezone support
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Convert a date to UTC string in given format
 * @param {string|Date} date - Date to format
 * @param {string} format - Format string (default: "YYYY-MM-DD")
 */
export const formatUTC = (date, format = "YYYY-MM-DD") => {
  return dayjs(date).utc().format(format);
};

/**
 * Convert a date to a specific timezone
 * @param {string|Date} date - Date to format
 * @param {string} tz - Timezone (e.g., "America/New_York")
 * @param {string} format - Format string
 */
export const formatInTimezone = (date, tz, format = "YYYY-MM-DD HH:mm") => {
  return dayjs(date).tz(tz).format(format);
};

/**
 * Get current UTC date
 */
export const getCurrentUTC = (format = "YYYY-MM-DD HH:mm:ss") => {
  return dayjs().utc().format(format);
};
export const formatDateToUTC1830 = (date) => {
  return date
    ? dayjs(date).utc().hour(18).minute(30).second(0).millisecond(0).toISOString()
    : undefined;
};
export const formatDateWithFixedTime = (date) => {
  if (!date) return undefined;
  return dayjs.utc(`${dayjs(date).format("YYYY-MM-DD")}T18:30:00.000Z`).toISOString();
};

export const formatDateWithFixedTimeNew = (date) => {
  if (!date) return undefined;
  // Ensure date is converted into ISO 8601 format with UTC midnight
  return dayjs(date).add(1, "day").startOf("day").toISOString();
};